import { Col, Typography } from "antd";

import CustomRow from "../../shared/costum-row/costum-row";

import "./styles.scss";
import CustomImage from "../../shared/custom-image/custom-image";
import useBreakpoints from "../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../constants/styles";
import { ARROW_LIGHT, ARROW_OPENER } from "../../constants/svgs";

const { Title, Text } = Typography;

interface AboutCardProps {
  title?: string;
  description?: string;
  imageSrc?: string;
}

const AboutCard = ({
  title = "In-House Products",
  description = "We don't just build for clients—we create our own innovative solutions to solve real-world problems, bringing cutting-edge tech to market.",
  imageSrc = "../img.jpg",
}: AboutCardProps) => {
  const currentBreakpoint = useBreakpoints();

  const isTabletOrMobile =
    currentBreakpoint === BREAKPOINTS.TABLET.type ||
    currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <CustomRow
      className="AboutCard"
      gutter={isTabletOrMobile ? [20, 20] : [60, 0]}
      justify={isTabletOrMobile ? "center" : "space-between"}
      align={"top"}
      isMarginNone
      isEdgeToEdge
    >
      <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
        <Title className="AboutCard-title">{title}</Title>
      </Col>
      <Col xxl={5} xl={5} lg={6} md={6} sm={24} xs={24}>
        <CustomImage className="AboutCard-image" src={imageSrc} />
      </Col>
      <Col xxl={8} xl={8} lg={9} md={9} sm={24} xs={24}>
        <Text className="AboutCard-description">{description}</Text>
        <div className="AboutCard-content-button">
          <span className="AboutCard-arrow AboutCard-arrow--light">{ARROW_LIGHT}</span>
          <span className="AboutCard-arrow AboutCard-arrow--opener">{ARROW_OPENER}</span>
        </div>
      </Col>
    </CustomRow>
  );
};

export default AboutCard;
